import { Routes } from '@angular/router'
import { adminGuard, affiliationGuard } from './services'

export const routes: Routes = [
  { path: '', redirectTo: 'affiliations', pathMatch: 'full' },
  {
    path: 'affiliations',
    canActivate: [affiliationGuard],
    loadChildren: () => import('./affiliations/affiliations.module').then(m => m.AffiliationsModule),
  },
  {
    path: 'organizations',
    canActivate: [adminGuard],
    loadChildren: () => import('./organizations/organizations.module').then(m => m.OrganizationsModule),
  },
  {
    path: 'personas',
    canActivate: [adminGuard],
    loadChildren: () => import('./personas/personas.module').then(m => m.PersonasModule),
  },
  {
    path: 'users',
    canActivate: [adminGuard],
    loadChildren: () => import('./users/users.module').then(m => m.UsersModule),
  },
  {
    path: 'admins',
    canActivate: [adminGuard],
    loadChildren: () => import('./admins/admins.module').then(m => m.AdminsModule),
  },
  {
    path: 'review-duplicates',
    canActivate: [adminGuard],
    loadChildren: () => import('./review-duplicates/review-duplicates.module').then(m => m.ReviewDuplicatesModule)
  },
]
